import React, { useRef, useEffect, useState, useCallback } from "react";
// import { postApiMethod } from "../services/global";
// import { getToken } from "../../utility/cookieUtils";
// import { BASE_URL } from "../services/config";
import text from "../text";
import { UseFormRegister, FieldError } from "react-hook-form";
import Button from "./ButtonField";
import { BASE_URL } from "Layout/Header";
import Modals from "./Modals";
import { postApiMethod } from "../../../utils/api/Global";

interface UploadFileFieldProps {
  type: string;
  placeholder?: string;
  name: string;
  register: UseFormRegister<any>;
  error?: FieldError;
  setValue: (name: string, value: any) => void;
  className?: string;
  id?: string;
  errMsgClassName?: string;
  disabled?: boolean;
  readOnly?: boolean;
  value?: boolean;
  uploadApi?: string; // API endpoint for file upload
  watch?: (name: string) => any; // Function to watch form values
  setError: (name: string, error: FieldError) => void; // Add setError
  signData?: any; // Optional signing data (specify more if needed)
  multiple?: boolean; // Allow multiple file uploads
}

const UploadFileField: React.FC<UploadFileFieldProps> = ({
  type,
  placeholder,
  name,
  register,
  error,
  setValue,
  className = "",
  id,
  errMsgClassName = "",
  disabled = false,
  readOnly = false,
  uploadApi,
  watch,
  setError,
  signData,
  multiple,
}) => {
  // const { watch } = useForm();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState("");

  const handleUpload = async (file: File) => {
    const fileName = file.name;
    const fileType = fileName
      .substr(fileName.lastIndexOf(".") + 1)
      .toLowerCase(); // Get the extension and convert to lowercase
    const formData = new FormData();
    if (file) {
      setValue(name, file);
      setError(name, null);
      // Check file size
      const fileSizeInBytes = file.size;
      const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // Convert to MB

      if (fileSizeInMB > 2) {
        setError(name, {
          type: "manual",
          message: "File size must be 2 MB or less!",
        });
        return;
      }

      // Check file format for JPEG and PNG
      if (fileType !== "jpg" && fileType !== "jpeg" && fileType !== "png") {
        setError(name, {
          type: "manual",
          message: "Invalid file format. Only JPEG and PNG are allowed.",
        });
        return;
      }

      // Append the file to FormData
      formData.append("filename", file); // Ensure this key matches what your server expects
      // Uncomment and use your upload API method
      const uploadRes = await postApiMethod({
        apiUrl: uploadApi,
        body: formData,
        // apiKey: await getToken("token"),
      });

      if (uploadRes?.status == 1) {
        setValue(name, uploadRes.data.filename, { shouldValidate: true });
        return uploadRes.data.filename;
      }
    }
  };

  const openModal = useCallback(
    (e: any) => {
      e.preventDefault();
      // Get the current value of the image upload field
      const watchData = watch(name); // Make sure 'name' corresponds to your form field
      if (!watchData) {
        return; // Prevent opening modal if the data is undefined
      }

      // Check if the data is a Blob and create a URL from it
      let url;
      if (watchData instanceof Blob) {
        url = URL.createObjectURL(watchData);
      } else {
        // url = BASE_URL + `${watchData?.slice(2)}`;
        // Handle if it’s base64 (you might need to adjust this)
      }

      setIsOpen(true); // Open the modal
      setModalData(url);
      window.open(url, "_blank");
    },
    [watch, name],
  );

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const registerData = register(name);
  //  const fileViewBtn = watch( name );
  const fileViewBtn = undefined;

  const multipleUpload = async (files: FileList) => {
    const uploadedFiles: string[] = [];
    const formData = new FormData();

    for (const file of files) {
      const fileName = file.name;
      const fileType = fileName.split(".").pop()?.toLowerCase(); // Get file extension
      const fileSizeInMB = file.size / (1024 * 1024); // Convert size to MB

      // File size validation (max 2MB)
      if (fileSizeInMB > 2) {
        setError(name, {
          type: "manual",
          message: `File "${fileName}" exceeds 2MB size limit!`,
        });
        return;
      }

      // File type validation (JPEG, PNG)
      if (!fileType || !["jpg", "jpeg", "png"].includes(fileType)) {
        setError(name, {
          type: "manual",
          message: `File "${fileName}" has an invalid format. Only JPEG and PNG are allowed.`,
        });
        return;
      }

      formData.append("filename", file); // Append file to FormData
    }

    try {
      const uploadRes = await postApiMethod({
        apiUrl: uploadApi,
        body: formData,
        // apiKey: await getToken("token"),
      });

      if (uploadRes?.status === 1) {
        setValue(name, uploadRes.data.filenames, { shouldValidate: true });
        return uploadRes.data.filenames; // Return array of uploaded filenames
      }
    } catch (error) {
      console.error("File upload failed:", error);
    }
  };

  return (
    <>
      {!multiple ? (
        <div>
          <div className="form-group">
            <input
              id={id}
              type={type}
              placeholder={placeholder}
              name={registerData.name}
              onChange={(e) => {
                if (type == "file") {
                  handleUpload(e.target.files[0]);
                }
              }}
              className={`${
                error ? " has-error" : ""
              }  ${" border border-custom-gray rounded-[4px] w-full p-2"}`}
              disabled={disabled}
            />

            <div>
              {error && (
                <span className="text-red-500  font-sm  text-[12px]">
                  {error.message}
                </span>
              )}
            </div>

            <div className="">
              <span className="text-xs -mt-12 font-roboto">
                {signData ? text.form.note : text.form.uploadNote}
              </span>
            </div>
          </div>
          <Button
            onClick={(e) => {
              openModal(e);
            }}
            name="View"
            className=""
          />
        </div>
      ) : (
        <div>
          <input
            id={id}
            type={type}
            multiple
            placeholder={placeholder}
            name={registerData.name}
            // onChange={(e) => {
            //   if (type == "file") {
            //     multipleUpload(e.target.files[0]);
            //   }
            // }}
            onChange={(event) => {
              const files = Array.from(event.target.files);
              multipleUpload(files);

              // setValue(field.name, field.multiple ? files : files[0]);
            }}
            className={`${
              error ? " has-error" : ""
            }  ${" border border-custom-gray rounded-[4px] w-full p-2"}`}
            disabled={disabled}
          />

          <div>
            {error && (
              <span className="text-red-500  font-sm  text-[12px]">
                {error.message}
              </span>
            )}
          </div>

          <div className="mt-2">
            {multiple ? (
              Array.isArray(watch(name)) &&
              watch(name).map((file, index) => (
                <div key={index}>
                  {typeof file === "string" ? (
                    <a
                      href={`/api/admin/${file}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button size="sm" color="green">
                        {"View"}
                      </Button>
                    </a>
                  ) : (
                    <p>{file.name}</p>
                  )}
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
        </div>
      )}

      <Modals
        modalIsOpen={modalIsOpen}
        openModal={openModal}
        closeModal={closeModal}
        modalData={modalData}
        url={modalData}
      />
    </>
  );
};

export default UploadFileField;
